import { SALUTATION } from "../constants";

export const getUUID = () =>{
  let dt = new Date().getTime();
  return ('xxxx-xxxx-4xxx-yxxx-qxxx'.replace(/[xy]/g, (c) => {
    let r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  })) ;
};
export const getLastDigit=(an, n)=>{
  return (an.substr(an.length-n));
};
export const getBankDisplayName = (name, number) =>{
  return `Barclaycard CL Apply Application ...${getLastDigit(number, 4)}`;
};
export const isSelectedField = (obj, ...fields) =>{
  const totalFields = fields.length;
  let validFields =0;
  for(let key in fields){
    if(obj[fields[key]]){
      validFields++;
    }
  }
  return totalFields === validFields;
};
export const getAccount = (accounts, type) =>{
  if(accounts && accounts.length > 0){
    const newAccounts= accounts.filter((acc)=>{
      return acc.newAccount && acc.accountType === type;
    });
    return newAccounts[newAccounts.length-1];
  }
  return null;
};
export const getSalutation = ()=>{
  const CURRENT_HOUR = new Date().getHours();
  if (CURRENT_HOUR >= 17) {
    return SALUTATION.EVENING;
  } else if (CURRENT_HOUR >= 12) {
    return SALUTATION.AFTERNOON;
  } else if (CURRENT_HOUR >= 5) {
    return SALUTATION.MORNING;
  } else {
    return SALUTATION.STANDARD;
  }
};

export const isValidDigit = (obj, key)=>{
  try {
    if(obj && key in obj){
      return (parseInt(obj[key])?true:false);
    }
    return false;
  }catch (e) {
    return false;
  }
};
export const isSameBankAccount = (obj_1, obj_2) => {
  if (obj_1 && obj_2) {
    return (obj_2.nickname === obj_1.nickname &&
      obj_2.accountNumber === obj_1.accountNumber &&
      obj_2.routingNumber === obj_1.routingNumber &&
      obj_2.externalAccountType === obj_1.externalAccountType);
  }
  return false;
};
export const splitRouting = (data, key) =>{
  if(data && data.data){
    let accountInfo = data.data[key];
    accountInfo = accountInfo?accountInfo.split(":"):null;
    if(accountInfo){
      return { acc: accountInfo[0], routing: accountInfo[1] };
    }
  }
  return null;
};
